import React, { useState } from 'react';
import OCRelatedIRsModal from './OCRelatedIRsModal';
import './Modal.css';

function OCBalancesModal({ balances, onClose, currentIrId }) {
    const [selectedOcId, setSelectedOcId] = useState(null);
    const [expandedPendingOc, setExpandedPendingOc] = useState(null);

    if (!balances) return null;

    const formatCurrency = (val) => {
        return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(val);
    };

    const formatNumber = (val) => {
        return new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
    };

    const togglePendingDetail = (ocId) => {
        setExpandedPendingOc(expandedPendingOc === ocId ? null : ocId);
    };

    return (
        <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1200 }}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ width: '1050px', maxWidth: '95%', maxHeight: '90vh', overflow: 'auto' }}>
                <div className="modal-header">
                    <h2>Detalle de Saldos por Orden de Compra</h2>
                    <button className="close" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body">
                    <div className="table-responsive">
                        <table className="comparison-table">
                            <thead>
                                <tr>
                                    <th>OC #</th>
                                    <th className="text-right">Total Original</th>
                                    <th className="text-right">Rec. en este IR</th>
                                    <th className="text-right">Recibido Acum.</th>
                                    <th className="text-right">Pendiente</th>
                                    <th>Otros IRs</th>
                                </tr>
                            </thead>
                            <tbody>
                                {balances.map((item, idx) => (
                                    <React.Fragment key={item.oc_id || idx}>
                                        <tr>
                                            <td><strong>#{item.oc_id}</strong></td>
                                            <td className="text-right">{formatCurrency(item.total || 0)}</td>
                                            <td className="text-right" style={{ fontWeight: 'bold', color: '#007bff' }}>
                                                {formatCurrency(item.received_in_this_ir || 0)}
                                            </td>
                                            <td className="text-right">{formatCurrency(item.received || 0)}</td>
                                            <td className="text-right">
                                                {item.pending > 0 ? (
                                                    <span
                                                        onClick={() => togglePendingDetail(item.oc_id)}
                                                        style={{
                                                            color: '#dc3545',
                                                            cursor: 'pointer',
                                                            textDecoration: 'underline',
                                                            fontWeight: 'bold'
                                                        }}
                                                        title="Click para ver detalle de pendientes"
                                                    >
                                                        {formatCurrency(item.pending)} {expandedPendingOc === item.oc_id ? '▲' : '▼'}
                                                    </span>
                                                ) : (
                                                    <span style={{ color: 'green' }}>$0,00</span>
                                                )}
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-info"
                                                    onClick={() => setSelectedOcId(item.oc_id)}
                                                    title="Ver otros Informes de Recepción para esta OC"
                                                >
                                                    🔍 Ver IRs ({item.ir_count || 0})
                                                </button>
                                            </td>
                                        </tr>
                                        {/* Fila expandible con detalle de pendientes */}
                                        {expandedPendingOc === item.oc_id && item.pending_items && item.pending_items.length > 0 && (
                                            <tr>
                                                <td colSpan="6" style={{ padding: '0', background: '#fff3f3' }}>
                                                    <div style={{ padding: '10px 20px' }}>
                                                        <strong style={{ color: '#dc3545' }}>Artículos pendientes de esta OC:</strong>
                                                        <table className="table" style={{ marginTop: '10px', marginBottom: '0', fontSize: '0.9em' }}>
                                                            <thead>
                                                                <tr style={{ background: '#ffe6e6' }}>
                                                                    <th>Código</th>
                                                                    <th>Descripción</th>
                                                                    <th className="text-right">Pedido</th>
                                                                    <th className="text-right">Recibido</th>
                                                                    <th className="text-right">Pendiente</th>
                                                                    <th className="text-right">Precio</th>
                                                                    <th className="text-right">Total Pend.</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {item.pending_items.map((pi, piIdx) => (
                                                                    <tr key={piIdx}>
                                                                        <td><code>{pi.article_code}</code></td>
                                                                        <td>{pi.article_description}</td>
                                                                        <td className="text-right">{formatNumber(pi.ordered_qty)}</td>
                                                                        <td className="text-right">{formatNumber(pi.received_qty)}</td>
                                                                        <td className="text-right" style={{ color: '#dc3545', fontWeight: 'bold' }}>
                                                                            {formatNumber(pi.pending_qty)}
                                                                        </td>
                                                                        <td className="text-right">{formatCurrency(pi.price)}</td>
                                                                        <td className="text-right" style={{ fontWeight: 'bold' }}>
                                                                            {formatCurrency(pi.pending_value)}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                                <tr className="table-footer">
                                    <td className="text-right"><strong>Total:</strong></td>
                                    <td className="text-right"><strong>{formatCurrency(balances.reduce((acc, c) => acc + c.total, 0))}</strong></td>
                                    <td className="text-right"><strong>{formatCurrency(balances.reduce((acc, c) => acc + (c.received_in_this_ir || 0), 0))}</strong></td>
                                    <td className="text-right"><strong>{formatCurrency(balances.reduce((acc, c) => acc + c.received, 0))}</strong></td>
                                    <td className="text-right"><strong>{formatCurrency(balances.reduce((acc, c) => acc + c.pending, 0))}</strong></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="modal-actions">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        Cerrar
                    </button>
                </div>
            </div>

            {selectedOcId && (
                <OCRelatedIRsModal
                    ocId={selectedOcId}
                    currentIrId={currentIrId}
                    onClose={() => setSelectedOcId(null)}
                />
            )}
        </div>
    );
}

export default OCBalancesModal;
